import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Square, Droplets, Zap } from 'lucide-react';
import './Spaces.css';

export const Spaces = () => {
  const spaces = [
    {
      title: 'Grand Lawn',
      description: 'Beautifully manicured open space surrounded by greenery, fountains, and soft architectural lighting. Perfect for grand receptions, stage setups, and mandap ceremonies.',
      capacity: 'Up to 1000 guests',
      features: ['Fountain Features', 'Architectural Lighting', 'Open Air Setting', 'Stage-Ready'],
      image: 'https://images.unsplash.com/photo-1747115275583-f93db102e4e3?w=800&q=80',
      icon: <Square size={40} />
    },
    {
      title: 'Banquet Halls',
      description: 'Air-conditioned elegantly designed halls adaptable for various events. Featuring ambient lighting and décor flexibility for any theme or style.',
      capacity: 'Up to 500 guests per hall',
      features: ['Fully Air-Conditioned', 'Flexible Décor', 'Ambient Lighting', 'Multiple Configurations'],
      image: 'https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?w=800&q=80',
      icon: <Users size={40} />
    },
    {
      title: 'Poolside Venue',
      description: 'Sparkling swimming pool area crafted for haldi, mehndi, or cocktail evenings. Features reflection of warm lights on water with floral accents and décor drapes.',
      capacity: 'Up to 300 guests',
      features: ['Swimming Pool', 'Festive Atmosphere', 'Water Reflections', 'Intimate Setting'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/bqqqlwie_IMG-20251012-WA0012.jpg',
      icon: <Droplets size={40} />
    },
    {
      title: 'Signature Lighting & Fountains',
      description: 'Our signature aesthetic lighting, themed stages, floral installations, and grand fountains create magical ambience throughout the venue.',
      features: ['LED Lighting Systems', 'Fountain Effects', 'Power Backup', 'Custom Configurations'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/j6o6ntwb_IMG-20251012-WA0021.jpg',
      icon: <Zap size={40} />
    }
  ];

  return (
    <div className="spaces-page">
      <section className="spaces-hero">
        <div className="container">
          <span className="section-subtitle">Explore</span>
          <h1 className="hero-medium">Spaces & Ambience</h1>
          <p className="body-large mt-24">
            From grand lawns to elegant halls, each space at The Green Valley is designed to create unforgettable moments
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          {spaces.map((space, index) => (
            <div key={index} className={`space-section ${index % 2 === 1 ? 'reverse' : ''}`}>
              <div className="space-content">
                <div className="space-icon">{space.icon}</div>
                <h2 className="heading-1 mb-24">{space.title}</h2>
                <p className="body-large mb-24">{space.description}</p>
                {space.capacity && (
                  <p className="space-capacity">
                    <strong>Capacity:</strong> {space.capacity}
                  </p>
                )}
                <div className="space-features">
                  <h3 className="heading-3 mb-16">Key Features</h3>
                  <ul className="feature-list">
                    {space.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <Link to="/contact" className="btn-primary mt-32">
                  Book This Space
                </Link>
              </div>
              <div className="space-image-wrapper">
                <img src={space.image} alt={space.title} className="space-image" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Rooms Preview */}
      <section className="section-padding rooms-preview">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Accommodation</span>
            <h2 className="heading-1">Luxury Guest Rooms</h2>
            <p className="body-large mt-16">
              12 fully air-conditioned rooms designed for elegance and relaxation
            </p>
          </div>
          <div className="rooms-grid">
            <div className="room-card">
              <h3 className="heading-2 mb-16">Premium Rooms</h3>
              <p className="body-regular mb-16">8 spacious premium rooms with modern furnishings, attached baths, and serene views</p>
              <Link to="/stay" className="btn-secondary">View Details</Link>
            </div>
            <div className="room-card">
              <h3 className="heading-2 mb-16">Deluxe Rooms</h3>
              <p className="body-regular mb-16">4 deluxe rooms offering enhanced luxury with elegant interiors and premium amenities</p>
              <Link to="/stay" className="btn-secondary">View Details</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="glass-card cta-card">
            <h2 className="hero-medium text-center">Ready to See Our Spaces?</h2>
            <p className="body-large text-center mt-24 mb-32">
              Schedule a visit to experience the beauty and elegance of The Green Valley firsthand
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">Book a Visit</Link>
              <a href="https://wa.me/918826372788?text=Hi!%20I'd%20like%20to%20schedule%20a%20venue%20tour." 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 className="btn-secondary">
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Spaces;
